import { useUser } from '@clerk/clerk-react';
import { Navigate, Outlet } from 'react-router-dom';
import { AppShell } from '@/components/ui/AppShell';
import { LoadingOverlay } from '@/components/ui/LoadingOverlay';

type Props = {
  requiredRole?: 'instructor' | 'student'; // Optional: If null, allow both
};

export const ProtectedLayout = ({ requiredRole }: Props) => {
  const { user, isLoaded } = useUser();

  if (!isLoaded) return <LoadingOverlay label="Verifying access..." />;

  // 1. Get Role from Metadata (Default to 'student' if missing)
  const userRole = (user?.publicMetadata?.role as string) || 'student';

  // 2. Security Check (If a specific role is required)
  if (requiredRole && userRole !== requiredRole) {
    // Redirect unauthorized users to their safe zone
    const redirectTarget = userRole === 'instructor' ? '/lobby' : '/lobby'; 
    // Note: Both go to /lobby, but Lobby.tsx determines what they see
    return <Navigate to={redirectTarget} replace />;
  }

  // 3. Render the AppShell and the Page
  return (
    <AppShell role={userRole as 'instructor' | 'student'}>
      <Outlet />
    </AppShell>
  );
};